module.exports = __webpack_public_path__ + "img/playstore.e9f4802a.png";